'use strict';

(function (angular) {
  angular.module('zp').factory('searchFiltersConfig', searchFiltersConfigFactory);

  /**@ngInject */
  function searchFiltersConfigFactory() {
    var venueFilters = [{
      name: 'Lokacija',
      alias: 'location',
      match: 'autocomplete',
      search: true,
      filter: false,
      colClass: 'col-md-6',
      control: 'googleplaces',
      defaultValue: {}
    }, /*{
       name: 'Tip prostora',
       alias: 'type',
       property: 'type',
       match: 'contains',
       colClass: 'col-md-3',
       control: 'dropdown',
       search: false,
       filter: true,
       options: {
        0: 'Sve',
        1: 'Sala',
        2: 'Restoran',
        3: 'Splav',
        4: 'Hotel',
        5: 'Salas',
        6: 'Ostalo'
       },
       values: ['*', 'sala', 'restoran', 'splav', 'hotel', 'salas', '%']
       }, {
       name: 'Broj Mesta',
       alias: 'maxCapacity',
       property: 'maxCapacity',
       match: 'range',
       search: false,
       filter: true,
       colClass: 'col-md-2',
       control: 'dropdown',
       options: {
        0: 'Sve',
        1: 'Do 100 mesta',
        2: 'Do 200 mesta',
        3: 'Do 300 mesta',
        4: 'Preko 300 mesta'
       },
       values: [{ min: 0, max: 999999999 }, { min: 0, max: 100 }, { min: 100, max: 200 }, { min: 200, max: 300 }, { min: 300, max: 999999 }]
       }, */{
      name: 'Pretraga',
      alias: 'search',
      property: 'name',
      match: 'contains',
      control: 'text',
      search: false,
      filter: true,
      colClass: 'col-md-6'
    }];

    var musicFilters = [{
      name: 'Lokacija',
      alias: 'location',
      match: 'autocomplete',
      search: true,
      filter: false,
      colClass: 'col-md-6',
      control: 'googleplaces',
      defaultValue: {}
    }, {
      name: 'Tip Muzike',
      alias: 'type',
      property: 'type',
      match: 'contains',
      control: 'dropdown',
      search: false,
      filter: true,
      colClass: 'col-md-6',
      options: {
        0: 'Sve',
        1: 'Bend',
        2: 'DJ'
      },
      values: ['*', 'muzika', 'dj']
    }, {
      name: 'Pretraga',
      alias: 'search',
      property: 'name',
      match: 'contains',
      control: 'text',
      search: false,
      filter: true,
      colClass: 'col-md-6'
    }];

    var jeweleryFilters = [{
      name: 'Lokacija',
      alias: 'location',
      match: 'autocomplete',
      search: true,
      filter: false,
      colClass: 'col-md-6',
      control: 'googleplaces',
      defaultValue: {}
    }, {
      name: 'Tip',
      alias: 'type',
      property: 'description',
      match: 'contains',
      control: 'dropdown',
      search: false,
      filter: true,
      colClass: 'col-md-6',
      options: {
        0: 'Sve',
        1: 'Burme',
        2: 'Vereničko prstenje'
      },
      values: ['*', '*', 'vereni']
    }, {
      name: 'Materijal',
      alias: 'meterial',
      property: 'description',
      match: 'contains',
      control: 'dropdown',
      search: false,
      filter: true,
      colClass: 'col-md-6',
      options: {
        0: 'Sve',
        1: 'Zlato',
        2: 'Srebro',
        3: 'Keramika',
        4: 'Dijamanti'
      },
      values: ['*', 'zlat', 'srebr', 'keramik', 'dijaman']
    }];

    var genericFilters = [{
      name: 'Lokacija',
      alias: 'location',
      match: 'autocomplete',
      search: true,
      filter: false,
      colClass: 'col-md-6',
      control: 'googleplaces',
      defaultValue: {}
    }, {
      name: 'Pretraga',
      alias: 'search',
      property: 'name',
      match: 'contains',
      control: 'text',
      search: false,
      filter: true,
      colClass: 'col-md-6'
    }];

    function searchFiltersConfig() {
      this['prostori'] = venueFilters;
      this['muzika'] = genericFilters;
      this['zlatare'] = genericFilters;
      this['vencanice'] = genericFilters;
      this['torte'] = genericFilters;
      this['fotografi'] = genericFilters;
      this['dekoracija-cvece'] = genericFilters;
      this['ketering'] = genericFilters;
      this['limuzine'] = genericFilters;
      this['beauty'] = genericFilters;
      this['momacko-devojacko'] = genericFilters;
    }
    return searchFiltersConfig;
  }
})(window.angular);